<template>

  <b-card class="card-statistics border border-secondary  ">
    <h1><center>Otomatik Sayaç Okuma Sistemi</center></h1><hr>
    <br>
    <br>
    <div>
      <b-form-select
        id="head"
        v-model="selected8"
        :options="options8"
        class="mb-1"
      >
        <b-form-select-option
          :value1="null"
          disabled
        >
          Sayaç Okuma Yapılabilmesi İçin Enerji Türünüzü Seçiniz!
        </b-form-select-option>
        <b-form-select-option value="yes">
          <b>Elektrik</b>
        </b-form-select-option>
        <b-form-select-option value="no">
          <center>Doğalgaz</center>
        </b-form-select-option>
        <b-form-select-option value="no">
          <b>Su</b>
        </b-form-select-option>
        <b-form-select-option value="no">
          <b>Güneş Enerji Kaynağı</b>
        </b-form-select-option>
      </b-form-select>
    </div><br>
    <div>
      <b-form-select
        id="head"
        v-model="selected8"
        :options="options8"
        class="mb-1"
      >
        <b-form-select-option
          :value1="null"
          disabled
        >
          Sayaçlar
        </b-form-select-option>
        <b-form-select-option value="yes">
          <b>Tümü </b>
        </b-form-select-option>
        <b-form-select-option value="yes">
          <b>A Deri Lojistik</b>
        </b-form-select-option>
      </b-form-select>
    </div><br>
    <b-row>
      <b-col
        md="6"
        xl="2"
        class="mb-1"
      >

        <!-- basic -->
        <b-form-group
          label="Okuma Başlangıç Tarihi"
          label-for="basicInput"
        >
          <b-form-input
            id="basicInput"
          />
        </b-form-group>
      </b-col>

      <b-col
        md="6"
        xl="2"
        class="mb-1"
      >
        <!-- input text with help -->
        <b-form-group>
          <label for="InputHelp">Okuma Bitiş Tarihi</label>

          <b-form-input id="InputHelp" />
        </b-form-group>
      </b-col>

      <b-col
        md="6"
        xl="2"
        class="mb-1"
      >
        <!-- disabled input -->
        <b-form-group
          label="Okuma Türü"
          label-for="disabledInput"
        >
          <b-form-select
            v-model="selected"
            :options="options"
          />
        </b-form-group>
      </b-col>

      <b-col
        md="6"
        xl="2"
      >
        <!-- readonly input -->
        <b-form-group><br>
          <b-button>Filtrele</b-button>
        </b-form-group>
      </b-col>
    </b-row>
    <br>
    <b-table
      id="tabb"
      responsive
      :items="items"
      :fields="fields"
      class="mb-0"
    >
      <template #cell(Phone)="data">
        <span class="text-nowrap">
          {{ data.value }}
        </span>
      </template>
      <!-- Optional default data cell scoped slot -->
      <template #cell()="data">
        {{ data.value }}

      </template>
    </b-table>

    <br>

    <baslatici id="kay" />
    <b-button id="iki">
      <feather-icon
        icon="ArrowUpRightIcon"
        size="15"
      />
      Excele Aktar
    </b-button>
    <b-button id="uc">
      <feather-icon
        icon="ArrowDownCircleIcon"
        size="15"
      />
      XML Olarak İndir
    </b-button>
    <br>

  </b-card>
</template>

<script>
import {
  BTable, BCard, BButton, BFormSelect, BFormSelectOption, BRow, BCol, BFormInput, BFormGroup,
} from 'bootstrap-vue'

import Baslatici from './Baslatici.vue'

export default {
  components: {
    BTable,
    BCard,
    BCol,
    BRow,
    BButton,
    BFormSelect,
    BFormSelectOption,
    BFormGroup,
    BFormInput,
    Baslatici,

  },
  data() {
    return {
      fields: [
        'id',
        'Sayaç Seri No',
        'Sayaç Adı',
        'Modeli',
        'Konumu',
        'Okuma Türü',
        'İlk Okuma',
        {
          key: 'Tarih', label: 'Son Okuma',
        },
        'Okunan Değer',
      ],
      selected: null,
      options: [
        { value: null, text: 'Otomatik Okuma' },
        { value: 'a', text: 'Manuel Okuma' },

      ],

      selected1: {
        title: 'Aperture',
        icon: 'ApertureIcon',
      },
      option: [{ title: 'Otomatik' }, { title: 'Manuel' }],

    }
  },
}
</script>
<style>
#head{
  background-color:antiquewhite
}
#tab{
  background-color: aqua;
}
#btn{
  position:relative;
        float: right;

}
#iki{
  position:relative;
        float: left;
        margin-right: 1rem;

}
#uc{

  position: relative;
float:left
}
#date{
  position: relative;
  float: left;
}
#kay{
  float: right;
}

</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';

</style>
